import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2de4d0c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-signup l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "確認コード入力", -1))
const _hoisted_4 = { class: "ha__sec ha-signup__sec" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-messages" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ha-message" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "ha-message__txt ha-message__txt--primary" }, [
      /*#__PURE__*/_createElementVNode("i"),
      /*#__PURE__*/_createElementVNode("span", null, "メールアドレスに届いた確認コードを入力してください。")
    ])
  ])
], -1))
const _hoisted_6 = { class: "p-signin__field-container" }
const _hoisted_7 = { class: "p-errors" }
const _hoisted_8 = {
  key: 0,
  class: "c-error"
}
const _hoisted_9 = { style: {"flex-wrap":"wrap"} }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 無効または有効期限切れのコードです。はじめからお手続きをやりなおしてください。新規会員登録は ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("こちら")
const _hoisted_12 = {
  key: 1,
  class: "c-error"
}
const _hoisted_13 = { style: {"flex-wrap":"wrap"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" このメールアドレスは既に使用されています。ログインは ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("こちら")
const _hoisted_16 = {
  key: 2,
  class: "c-error"
}
const _hoisted_17 = { class: "p-fields" }
const _hoisted_18 = { class: "c-field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "confirmationCode"
}, "確認コード", -1))
const _hoisted_20 = { class: "c-field__body" }
const _hoisted_21 = { class: "c-field__input" }
const _hoisted_22 = { class: "c-field has-submit has-mt" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "送信する", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "p-signin__txt" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("確認コードが届かない場合は ")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "コードを再送する", -1))
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LinkageSignupProgress = _resolveComponent("LinkageSignupProgress")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createVNode(_component_LinkageSignupProgress, { signupProgress: "SignupCode" }),
        _hoisted_5,
        _createVNode(_component_Form, {
          onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.confirmConfirmationCode, this))),
          "validation-schema": _ctx.schema
        }, {
          default: _withCtx(({ errors, meta }) => [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("div", _hoisted_7, [
                (_ctx.errorMsgRef === 'ExpiredCodeException')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, [
                        _hoisted_10,
                        _createVNode(_component_router_link, {
                          to: { name: _ctx.routeNames.SIGNUP },
                          class: "c-link c-link--primary"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ])
                    ]))
                  : (_ctx.errorMsgRef === 'AliasExistsException')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_router_link, {
                            to: { name: _ctx.routeNames.LOGIN },
                            class: "c-link c-link--primary"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.errorMsgRef), 1))
              ], 512), [
                [_vShow, _ctx.errorMsgRef]
              ]),
              _createElementVNode("fieldset", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createVNode(_component_Field, {
                        type: "text",
                        id: "confirmationCode",
                        name: "confirmationCode",
                        modelValue: _ctx.confirmationCodeRef,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.confirmationCodeRef) = $event)),
                        placeholder: "確認コードを入力",
                        required: ""
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.confirmationCode), 513), [
                  [_vShow, errors.confirmationCode]
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "ha-btn is-submit",
                    disabled: !meta.valid || _ctx.isDeterringRef
                  }, _hoisted_25, 8, _hoisted_23)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"]),
        _createElementVNode("p", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("a", {
            class: "c-link c-link--primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.resendConfirmationCode, this)))
          }, _hoisted_29)
        ])
      ])
    ])
  ]))
}